// extracted by mini-css-extract-plugin
module.exports = {"nameBlock":"partnersBlock_nameBlock__jCy_k","partner":"partnersBlock_partner__ml7Ow","partnersGrid":"partnersBlock_partnersGrid__h0A2G"};